import { parseDate } from "../../../utils/date/date";
import { TaskTagsTaskType } from "../../data/TaskTags";

const MS_PER_DAY = 1000 * 60 * 60 * 24;
const DAYS_ONE_WEEK = 7;
const DAYS_ONE_MONTH = 30;

/**
 * The urgency dot for a deadline, or `undefined` when there is no usable deadline to colour.
 *
 * Returning `undefined` rather than a colour matters: an absent or unparseable date used to reach
 * `parseDate` and produce an invalid `Date`, whose comparisons are all false, so the function fell
 * through to `onTrack` — a task with no deadline rendered a confident green dot. A missing deadline
 * is now the absence of a signal, and the card omits the dot entirely.
 */
export const getDotModifier = (dueDate?: string): string | undefined => {
  if (!dueDate) return undefined;

  const due = parseDate(dueDate);
  if (Number.isNaN(due.getTime())) return undefined;

  const now = Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate());
  const daysUntilDue = Math.ceil((due.getTime() - now) / MS_PER_DAY);

  if (daysUntilDue < DAYS_ONE_WEEK) return "TaskCard_dot_urgent";
  if (daysUntilDue < DAYS_ONE_MONTH) return "TaskCard_dot_warning";
  return "TaskCard_dot_onTrack";
};

/** A task is either driven by a workflow step or standalone ("general"). Workflow wins if both are set. */
export const getTaskType = (hasWorkflow?: boolean, isGeneral?: boolean): TaskTagsTaskType | undefined => {
  if (hasWorkflow) return "workflow";
  if (isGeneral) return "general";
  return undefined;
};
